import { createRouter, createWebHistory } from 'vue-router'
import { supabase } from '../lib/supabase'
import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView.vue'
import ProductView from '../views/ProductsView.vue'
import ContactView from '../views/ContactView.vue'
import BlogView from '../views/BlogView.vue'
import BlogPostView from '../views/BlogPostView.vue'
import LoginView from '../views/LoginView.vue'
import EbookView from '../views/EbookView.vue'
import CmmsColombiaView from '../views/CmmsColombiaView.vue'
import GmaoLatamView from '../views/GmaoLatamView.vue'
import ThankYouDemoView from '../views/ThankYouDemoView.vue'
import LandingB2BView from '../views/LandingB2BView.vue'
import PricingView from '../views/PricingView.vue'

// Definición de rutas
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView,
  },
  {
    path: '/products',
    name: 'products',
    component: ProductView,
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView,
  },
  {
    path: '/blog',
    name: 'blog',
    component: BlogView,
  },
  {
    path: '/blog/:slug',
    name: 'blog-post',
    component: BlogPostView,
  },
  {
    path: '/ebook',
    name: 'ebook',
    component: EbookView,
  },
  {
    path: '/cmms-colombia',
    name: 'cmms-colombia',
    component: CmmsColombiaView,
  },
  {
    path: '/gmao-latinoamerica',
    name: 'gmao-latinoamerica',
    component: GmaoLatamView,
  },
  {
    path: '/gracias-demo',
    name: 'thank-you-demo',
    component: ThankYouDemoView,
  },
  {
    path: '/software-mantenimiento-cmms',
    name: 'landing-b2b',
    component: LandingB2BView,
    meta: {
      title: 'Fourin - Software CMMS/GMAO para Mantenimiento Industrial B2B',
      description: 'Controla el mantenimiento y los activos de tu empresa desde un solo lugar. Software CMMS/GMAO líder para mantenimiento preventivo B2B.'
    }
  },
  {
    path: '/precios',
    name: 'precios',
    component: PricingView,
    meta: {
      title: 'Precios y planes - Fourin | Software CMMS/GMAO',
      description: 'Planes pensados para equipos de mantenimiento en crecimiento. Empieza gratis, crece cuando estés listo. Sin contratos anuales forzados.'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/AdminView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/editor/:id',
    name: 'admin-editor-edit',
    component: () => import('../views/EditorView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/editor',
    name: 'admin-editor-new',
    component: () => import('../views/EditorView.vue'),
    meta: { requiresAuth: true },
  },
]

// Configuración del router
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Si hay un hash en la URL, navegar a ese elemento
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
        top: 0,
      }
    }

    // Si hay una posición guardada (navegación hacia atrás/adelante)
    if (savedPosition) {
      return savedPosition
    }

    // Para navegación normal, ir al inicio de la página
    return {
      top: 0,
      behavior: 'smooth',
    }
  },
})

router.beforeEach(async (to, from, next) => {
  // Manejo de SEO (Title y Meta description dinámicos si existen en la ruta)
  if (to.meta.title) {
    document.title = to.meta.title as string;
  } else {
    document.title = 'Fourin - Software CMMS/GMAO en Colombia | Gestión de Activos';
  }

  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    if (to.meta.description) {
      metaDescription.setAttribute('content', to.meta.description as string);
    } else {
      metaDescription.setAttribute('content', 'Software CMMS/GMAO líder en Colombia y LATAM. Fourintrack te ayuda a gestionar activos, mantenimiento preventivo y predictivo. Reduce paradas, costos y riesgos. Prueba gratis 14 días.');
    }
  }

  // Verificar si la ruta requiere autenticación
  if (to.meta.requiresAuth) {
    try {
      // Obtener la sesión actual
      const { data: { session } } = await supabase.auth.getSession()

      if (session && session.user) {
        // Usuario autenticado, permitir acceso
        next()
      } else {
        // Usuario no autenticado, redirigir al login
        console.log('Acceso denegado: Usuario no autenticado')
        next({ path: '/login', query: { from: 'admin' } })
      }
    } catch (error) {
      console.error('Error al verificar autenticación:', error)
      // En caso de error, redirigir al login por seguridad
      next({ path: '/login', query: { from: 'admin' } })
    }
  } else {
    // Ruta no requiere autenticación, permitir acceso
    next()
  }
})

export default router
